/** Validacion del acceso movil (Yup, con su test). */
import * as yup from 'yup';

export const loginSchema = yup.object({
  email: yup.string().required('El correo es obligatorio').email('Correo invalido'),
  password: yup.string().required('La clave es obligatoria').min(1, 'La clave es obligatoria'),
});

export type LoginForm = yup.InferType<typeof loginSchema>;
